import RaygunUser from "@pga/react-raygun";
import { withAuthProvider } from "../../lib/auth";

export default withAuthProvider(RaygunUser);
